<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_PleaseSelectTheManifestYouWishToDelete')"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
      class="app-main-inner"
    >
      <el-table
        ref="multipleTable"
        border
        :data="manifestGoods"
        tooltip-effect="dark"
        style="width: 100%"
        height="300px"
        row-key="uuid"
        :span-method="spanMethod"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
        />
        <el-table-column
          prop="soNo"
          :label="$t('CargoMsg.Cargo_BLNo')"
          width="220"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.soNo }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="containerNo"
          :label="$t('CargoMsg.Cargo_ContainerNo')"
          width="220"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.containerNo }}</span>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <br>
      <el-form v-if="isRongeTong">
        <el-form-item :label="$t('Message.ReasonForDeletion')" required>
          <el-input v-model="reason" class="custom-textarea" :rows="4" type="textarea" style="width:70%;" />
        </el-form-item>
      </el-form>
      <div>
        <span>{{ $t('CargoMsg.Cargo_TheManifestYouWishToDeleteTips') }}</span>
      </div>
      <span slot="footer">
        <el-button no="confirm" type="primary" @click="confirmDelete">{{ $t('CargoMsg.Cargo_ConfirmDelete') }}</el-button>
        <el-button no="close" @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { deleteRongeTongKeeper, deleteSeaHousekeeper, deleteWseKeeper } from '@/api/seaExport/manifestInfo'
import { getLoading } from '@/utils/utilBaseElement'
import $store from '@/store'

export default {
  name: 'ChooseSeaHouseDelDialog',
  props: {
    visible: { type: Boolean, required: true },
    manifestInfoUuid: { type: String, required: true },
    isWseChannel: { type: Boolean, default: false },
    isRongeTong: { type: Boolean, default: false },
    manifestGoods: { type: Array, default: () => [] },
    containerNoMap: { type: Object, default: () => {} }
  },
  data() {
    return {
      innerVisible: false,
      multipleSelection: [],
      reason: ''
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange(val) {
      console.info('val', val)
      this.multipleSelection = val
    },
    confirmDelete() {
      const keys = this.getDelData()
      const param = {
        uuid: this.manifestInfoUuid,
        updateSeaHouseGoodInfoKeys: keys
      }
      if (this.isWseChannel) {
        param.officeId = $store.getters.currentOfficeId
        this.loading = getLoading()
        deleteWseKeeper(param).then(res => {
          if (res.code === '0') {
            this.$message.success(this.$t('SeaExport.DeleteSucceeded'))
            this.$emit('reload')
          }
        }).finally(() => {
          this.loading.close()
        })
      } else if (this.isRongeTong) {
        if (!this.reason) {
          this.$message.error(this.$t('Message.ReasonForDeletionNotEmpty'))
          return
        }
        param.officeId = $store.getters.currentOfficeId
        param.reason = this.reason
        param.delType = keys.length === this.manifestGoods.length ? 1 : 2
        this.loading = getLoading()
        deleteRongeTongKeeper(param).then(res => {
          if (res.ok) {
            this.$message.success(this.$t('SeaExport.DeleteSucceeded'))
            this.$emit('reload')
            this.reason = ''
            this.innerVisible = false
          } else {
            this.$message.error(res.message)
          }
        }).finally(() => {
          this.loading.close()
        })
      } else {
        deleteSeaHousekeeper(param).then(res => {
          if (res.code === '0') {
            this.$message.success(this.$t('SeaExport.DeleteSucceeded'))
            this.$emit('reload')
          }
        })
      }
    },
    getDelData() {
      const delContainerNos = []
      // 获取删除的数据
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        for (const data of this.multipleSelection) {
          delContainerNos.push(data.containerNo)
        }
      }
      let keys = []
      for (const key of Object.keys(this.containerNoMap)) {
        if (delContainerNos.length === 0 || delContainerNos.indexOf(key) > -1) {
          keys = keys.concat(this.containerNoMap[key])
        }
      }
      return keys
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      // 第一列
      if (columnIndex === 1) {
        return {
          rowspan: 1,
          colspan: 1
        }
      }
      const rowspan = row.rowspan
      if (rowspan === 0) {
        return {
          rowspan: 0,
          colspan: 0
        }
      }
      return {
        rowspan: row.rowspan,
        colspan: 1
      }
    }
  }
}
</script>

<style scoped>

</style>
